import styles from '../styles/InvalidMetricsMessage.module.css'

export const InvalidMetricsMessage = () => {
  return (
    <div className={styles.invalidMetricsMessage}>
      <p>Some metrics may be invalid</p>
    </div>
  )
}
